import script from "./SourcePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcePage.vue?vue&type=script&setup=true&lang=js"

import "./SourcePage.vue?vue&type=style&index=0&id=7e3cd3f4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3cd3f4"]])

export default __exports__